import { findMax } from './common_product_list_pro'
cb.define([], function () { //商品列表
  var PC_pc_goodsproductskuprolist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let gridModel = viewmodel.getGridModel();
      // gridModel.on('beforeLoad', function(data) {
      //   data.isDistinct = true;
      // });
      const startOrStop = (args) => {
        let selectedRows = [];
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
          selectedRows.push(gridModel.getRow(args.params.index));
        } else {
          selectedRows = gridModel.getSelectedRows();
          if (!selectedRows.length) {
            cb.utils.alert('未选择商品！', 'warning');
            return false;
          }
        }
        let _selectRows;
        // 'productId_stopstatus' true -> 停用； false->启用
        switch (args.cItemName) {
          case "btnBatchEnable": // 启用 
          case "btnEnable": // 启用 
            _selectRows = selectedRows.filter(v => v["productSKUDetail!stopstatus"] === 1 || v["productSKUDetail!stopstatus"] === true || v["productSKUDetail!stopstatus"] === 'true')
            break;
          case "btnBatchDisable": // 停用
          case "btnDisable": // 停用
            _selectRows = selectedRows.filter(v => v["productSKUDetail!stopstatus"] === 0 || v["productSKUDetail!stopstatus"] === false || v["productSKUDetail!stopstatus"] === 'false')
            break;
          default:
        }
        if (!_selectRows.length) { //审核未通过
          cb.utils.alert('请选择未' + args.cShowCaption + '状态的商品', 'warning');
          return false;
        }
        selectedRows = _selectRows
        let datas = [];
        let length = selectedRows.length;
        for (let i = 0; i < length; i++) {
          datas.push({
            "name": selectedRows[i]["productId_name"],
            "id": selectedRows[i]["id"],
            "productId": selectedRows[i]["productId"],
            "isCreator": selectedRows[i]["isCreator"],
            "biz": args.cParameter,
            "productApplyRangeId": selectedRows[i]["productApplyRangeId"]
          });
        }
        Ajax(args, datas)
      }
      // 启用
      viewmodel.on("batchenable", function (args) {
        startOrStop(args)
      });
      // 停用
      viewmodel.on("batchdisable", function (args) {
        let selectedRows = viewmodel.getGridModel().getSelectedRows();
        if (!(args.params && args.params.index >= 0) && !selectedRows.length) {
          cb.utils.alert('未选择商品！', 'warning');
          return false;
        }
        // 判断是否是自建商品 
        // 1、自建商品 需要提示
        // 2、被分配的商品 不需要提示
        if (args.params && args.params.index >= 0) {
          let _selectedRow = viewmodel.getGridModel().getRow(args.params.index);
          if (_selectedRow.orgName === _selectedRow.creator_orgId_Name) {
            cb.utils.confirm(`物料停用时会自动将共享给下级组织的物料一并停用并下架。`, function () {
              startOrStop(args)
            });
          } else {
            startOrStop(args)
          }
          return false
        }
        cb.utils.confirm(`物料停用时会自动将共享给下级组织的物料一并停用并下架。`, function () {
          startOrStop(args)
        });
      });
      // 启用/停用 按钮
      gridModel.on('afterSetDataSource', () => {
        const rows = gridModel.getRows();
        const actions = gridModel.getCache('actions');
        const actionsStates = [];
        rows.forEach(data => {
          const actionState = {};
          actions.forEach(action => {
            actionState[action.cItemName] = { visible: true };
            if (data["productSKUDetail!stopstatus"]) {
              actionState["btnEnable"] = { visible: true };
              actionState["btnDisable"] = { visible: false };
            } else {
              actionState["btnEnable"] = { visible: false };
              actionState["btnDisable"] = { visible: true };
            }
          });
          actionsStates.push(actionState);
        });
        gridModel.setActionsState(actionsStates);
      });
      gridModel.on('beforeDblClick', (args) => {
        args.source = 'cargoFile';           
        args.carryParams.productApplyRangeId = args.rowData.productApplyRangeId;                
        args.carryParams.isCreator = args.rowData.isCreator;                
        args.carryParams.isApplied = args.rowData.isApplied;  
        args.carryParams.id = args.rowData.productId;  
        args.carryParams.mode = 'browse'    
        args.ids = {
          customerId: args.rowData.customerId,
          shopId: args.rowData.shopId,
          orgId: args.rowData.orgId
        }
      })
      viewmodel.on('beforeEdit', (args) => {                
        args.carry.carryParams.productApplyRangeId = args.carry.rowData.productApplyRangeId;                
        args.carry.carryParams.isCreator = args.carry.rowData.isCreator;                
        args.carry.carryParams.isApplied = args.carry.rowData.isApplied;     
        args.carry.carryParams.id = args.carry.rowData.productId;     
        args.carry.carryParams.mode = 'edit'    
        args.carry.ids = {
          customerId: args.carry.rowData.customerId,
          shopId: args.carry.rowData.shopId,
          orgId: args.carry.rowData.orgId
        }       
      });
      const Ajax = (args, datas) => {
        var proxy = cb.rest.DynamicProxy.create({
          ensure: { url: args.cSvcUrl, method: args.cHttpMethod }
        });
        var params = { billnum: "pc_goodsproductskuprolist", action: args.cAction, data: JSON.stringify(datas) }
        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          let { count, failCount, messages, sucessCount } = result;
          if (sucessCount) {
            cb.utils.alert(args.cShowCaption + '成功' + sucessCount + '条', 'success');
          }
          if (failCount !== undefined) {
            messages.forEach(v => {
              cb.utils.alert(v, 'warning');
            })
            viewmodel.execute('back');
            return false
          }
          cb.utils.alert("操作成功", 'success');
          viewmodel.execute('back');
        });
      }
      //批量上下架
      function _fnshelve(args) {
        let selectedRows;
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择商品', 'warning');
            return false;
          }
          selectedRows.push(gridModel.getRow(args.params.index));
        } else {
          selectedRows = gridModel.getSelectedRows();
          if (!selectedRows.length) {
            cb.utils.alert('未选择商品', 'warning');
            return false;
          }
          // 储值卡的商品
          let _selectRows = selectedRows.filter(v => v.virtualProductAttribute == 1);
          if (_selectRows.length) {
            cb.utils.alert('储值卡商品不能上下架', 'warning');
          }
          // 被分配未被编辑的商品
          _selectRows = selectedRows.filter(v => !v.isApplied);
          if (_selectRows.length) { //审核未通过
            cb.utils.alert('被分配未被编辑的商品不能上下架', 'warning');
            return false;
          }
          // 停用状态的商品
          _selectRows = selectedRows.filter(v => v["detail!stopstatus"]);
          if (_selectRows.length) {
            cb.utils.alert('停用状态的商品不能上下架', 'warning');
          }
          // 非储值卡、停用状态的、被分配未被编辑商品
          _selectRows = selectedRows.filter(v => v.virtualProductAttribute != 1 && v.isApplied && !v["detail!stopstatus"]);
          if (!_selectRows.length) { //审核未通过
            return false;
          }
          const userType = cb.rest.AppContext.user ? cb.rest.AppContext.user.userType : null;
          let shopProIfCheck = cb.rest.AppContext.option ? cb.rest.AppContext.option.shopProIfCheck : null;
          if (userType === 4 || userType === 5) { // 商家操作员登陆
            switch (shopProIfCheck) {
              case '1':
                _selectRows = _selectRows.filter(v => !v.isCreator || (v.isCreator && v.platFormStaus === 1));
                if (!_selectRows.length) {
                  cb.utils.alert('商家商品新建和修改时需要审核后才能上架', 'warning')
                  return false
                }
                break;
              case '2':
                _selectRows = _selectRows.filter(v => !v.isCreator || (v.isCreator && v.platFormStaus === 1));
                if (!_selectRows.length) {
                  cb.utils.alert('商家商品未通过审核不能上下架', 'warning')
                  return false
                }
                break;
              default:
            }
          }
          let __selectRows = [];
          switch (args.cItemName) {
            case "btnSKUUMallUp":
              __selectRows = _selectRows.filter(v => !!v['productSKUDetail!status'] === false)
              break;
            case "btnSKUUMallDown":
              __selectRows = _selectRows.filter(v => !!v['productSKUDetail!status'] === true)
              break;
            case "btnSKUUOrderUp":
              __selectRows = _selectRows.filter(v => !!v['productSKUDetail!ustatus'] === false)
              break;
            case "btnSKUUOrderDown":
              __selectRows = _selectRows.filter(v => !!v['productSKUDetail!ustatus'] === true)
              break;
            default:
          }
          if (!__selectRows.length) {
            cb.utils.alert(('请选择未' + args.cShowCaption + '的货品'), 'warning');
            return false
          }
          selectedRows = _selectRows
        }
        var datas = [];
        var length = selectedRows.length;
        for (var i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "productId": selectedRows[i]["productId"],
            "isCreator": selectedRows[i]["isCreator"],
            "biz": args.cParameter,
            "productApplyRangeId": selectedRows[i]["productApplyRangeId"]
          });
        }
        Ajax(args, datas)
      }
      viewmodel.on('skushelve', function (args) {
        _fnshelve(args)
      });
      viewmodel.on('skuunshelve', function (args) {
        _fnshelve(args)
      });
      //商品标签字段所在的隐藏的viewmodel
      var tagReferModel = new cb.models.ReferModel({ cRefType: 'pc_tagref', multiple: 'true' });
      viewmodel.addProperty('tagName', tagReferModel);
      tagReferModel.setVisible(false)
      //加入商品标签的批量操作
      viewmodel.on('batchtag', function (args) {
        tagReferModel.setCache('args', args);
        tagReferModel.browse(true);
      });
      viewmodel.on('batchcleartag', function (args) {
        tagReferModel.setCache('args', args);
        tagReferModel.setCondition({ option: 'clear' });
        tagReferModel.browse(true);
      });
      //设置商品标签之前判断是否选择商品
      tagReferModel.on('beforeBrowse', function (data) {
        var selectedRows = viewmodel.getGridModel().getSelectedRows();
        if (selectedRows == undefined || selectedRows.length == 0) {
          cb.utils.alert('未选择货品', 'warning');
          return false;
        }
      });
      //设置商品标签之前判断是否选择商品
      tagReferModel.on('afterValueChange', function (args) {
        Object.assign(args, this.getCache('args'));
        if (args && args.value && !args.value.length) {
          cb.utils.alert('未选择商品标签', 'warning');
          return false
        }
        if (args.cAction === 'batchtag') {
          let tag_positionArr = args.value.map(val => {
            if (val.scope.indexOf('1') >= 0) {
              return val.tag_position
            }
          })
          let { max } = findMax(tag_positionArr);
          if (max > 1) {
            cb.utils.alert('前端展示的标签位置是唯一的', 'warning');
            return false
          }
        }
        var selectedRows = viewmodel.getGridModel().getSelectedRows();
        if (!selectedRows.length) {
          cb.utils.alert('未选择货品', 'warning');
          return false
        }
        let tags = args.value.map(v => {
          return (v.id).toString()
        })
        var datas = [];
        var length = selectedRows.length;
        for (var i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "tags": tags
          });
        }
        Ajax(args, datas)
      })
      // 商品档案 - 标签 格式化
      gridModel.setColumnState('skuTag', 'formatter', (rowInfo, rowData) => {
        return {
          formatterKey: 'ProductLabel',
          props: { rowInfo, rowData }
        }
      })
      // 商品档案 - 商品名称 格式化
      gridModel.setColumnState('name', 'formatter', (rowInfo, rowData) => {
        return {
          formatterKey: 'ProductBrand',
          props: { rowInfo, rowData }
        }
      });
      gridModel.on('dblClick', function (args) {
        //货品列表进入商品档案，把参数中的ID替换为商品ID
        args.id = args.productId;
      });

      //导出时将skuId+rangeId赋值到ids
      viewmodel.on('beforeBatchoutput', (args) => {
        if (gridModel) {
          let selectedRows = gridModel.getSelectedRows();
          let composeIds = "";
          for (let i = 0; i < selectedRows.length; i++) {
            composeIds += selectedRows[i]["id"].toString() + "_" + selectedRows[i]["productApplyRangeId"].toString();
            if (i < selectedRows.length - 1) {
              composeIds += ",";
            }
          }
          args.data.ids = "composeIds:" + composeIds;
        }
      });
    }
  }
  try {
    module.exports = PC_pc_goodsproductskuprolist_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_goodsproductskuprolist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_goodsproductskuprolist_VM.Extend.js